(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('userService', userService);

	function userService($http, $q, promiseUtilityService, _, assetCommonConfig, userMapper, uriUtility) {
		return {
			getCurrentUserAsync: function () {
				return $http.get(assetCommonConfig.accountServicesBaseUri + 'users/me')
					.then(function(response) {
						return userMapper.mapDetails(response.data);
					})
					.catch(function() {
						return $q.reject('error fetching current user');
					});
			},

			getUserDetailsAsync: function (id) {
				return $http.get(uriUtility.fromPattern(assetCommonConfig.accountServicesBaseUri + 'users/{id}', { id: id }))
					.then(function (response) {
						return userMapper.mapDetails(response.data);
					});
			},

			searchUsersAsync: function (search, cancellationToken) {
				search = search && search.trim();
				if (!search)
					return promiseUtilityService.fromResult(null);

				return $http.get(uriUtility.fromPattern(assetCommonConfig.accountServicesBaseUri + 'users', { q: search }), { timeout: cancellationToken })
					.then(function (response) {
						return response && response.data &&
							userMapper.mapDetails(response.data.users);
					});
			},

			signin: function (email, password) {
				return $http({
					method: 'post',
					url: assetCommonConfig.signInUri,
					data: {
						email: email,
						password: password
					}
				});
			},

			getSingleSignInScriptAsync: function () {
				return $http.get(assetCommonConfig.singleSignInScriptUri)
					.then(function (response) {
						return response && response.data && response.data.script;
					});
			}
		};
	}
	userService.$inject = ['$http', '$q', 'promiseUtilityService', '_', 'assetCommonConfig', 'userMapper', 'uriUtility'];
})();
